export default __webpack_public_path__ + "static/livechat-e5f2b3b156a351a9e000ebb7e1524b61.png";